export default {
    computed: {
        headers() {
            const fields = [
                {
                    value: 'name',
                    text: this.$t('labels.name'),
                    sortable: true,
                    type: 'string',
                },
                {
                    value: 'fullAddress',
                    text: this.$t('labels.address'),
                    sortable: true,
                    type: 'string',
                },
                {
                    value: 'comment',
                    text: this.$t('labels.address_details'),
                    sortable: true,
                    type: 'string',
                },
            ]

            return fields
        },
    },
}
